<!-- jobs.component.html -->
<div class="container-fluid flex flex-col h-full">
  <div class="bg-gradient-to-b from-transparent to-white flex-grow">
    <mat-drawer-container class="h-full min-h-[calc(100dvh-72px)]" autosize>
      <mat-drawer [mode]="'over'" #drawer class="md:min-w-[800px]">
        <div class="p-4 md:p-6">
          <!-- Back button row -->
          <div class="mb-4 sticky top-2 z-[999]">
            <button mat-icon-button (click)="drawer.close()"
              class="!text-white !bg-[#212529] hover:!bg-[#2c3238] transition-colors !flex !items-center !justify-center">
              <mat-icon>arrow_back</mat-icon>
            </button>
          </div>
          <form [formGroup]="userForm" (ngSubmit)="addUser()" class="flex flex-col gap-4">

            <!-- Header -->
            <div class="bg-[#212529] p-4 mb-4 w-full">
              <h1 class="text-lg md:text-3xl font-semibold text-white">Add User</h1>
              <p class="text-indigo-100 mt-1">Enter valid user details</p>
            </div>

            <mat-form-field appearance="outline" class="w-full">
              <mat-icon matPrefix class="text-gray-400">person</mat-icon>
              <p mat-label>Name</p>
              <input matInput formControlName="name" placeholder="Enter user name" pattern="[a-zA-Z ]+">
              <mat-error>Please enter a valid name</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="w-full">
              <mat-icon matPrefix class="text-gray-400">mail</mat-icon>
              <p mat-label>Email</p>
              <input matInput formControlName="email" placeholder="Enter user email">
              <mat-error>Please enter a valid email</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="w-full">
              <mat-icon matPrefix class="text-gray-400">key</mat-icon>
              <p mat-label>Role</p>
              <mat-select matInput formControlName="role" placeholder="Select Role">
                @for(role of roles();track role) {
                <mat-option [value]="role">{{role | titlecase}}</mat-option>
                }
              </mat-select>
              <mat-error>Please enter a role</mat-error>
            </mat-form-field>

            <button [disabled]="userForm.invalid" mat-stroked-button class="button-with-suffix-icon ml-auto">
              @if (loaders().addUser) {
              <mat-spinner diameter="20"></mat-spinner>
              } @else {
              <ng-container>
                <span>Send Invite</span>
                <mat-icon class="!transform scale-75">send</mat-icon>
              </ng-container>
              }
            </button>
          </form>
        </div>
      </mat-drawer>

      <div class="p-4 md:p-6">
        <div class="flex justify-between items-center mt-4 mb-6">
          <h1 class="text-3xl font-bold text-gray-800">Manage Users</h1>
          <button mat-button color="primary" (click)="getAvailableRoles();drawer.open()">
            <mat-icon>add</mat-icon>
            Add User
          </button>
        </div>

        <div class="flex flex-col items-center gap-3">
          @if (loaders().users) {
          <div class="text-center py-12 bg-gray-50 rounded-lg col-span-3">
            <mat-spinner diameter="40"></mat-spinner>
            </div>
          } @else {
          @if (data().length > 0;) {
          <div class="overflow-x-scroll max-w-[100vw] w-full">
          <table mat-table [dataSource]="dataSource" class="rounded-2xl custom-table">

            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef> User Name </th>
              <td mat-cell *matCellDef="let element">
                <div class="user-info">
                  <mat-icon class="user-icon">person</mat-icon> {{element.name | titlecase}}
                </div>
              </td>
            </ng-container>

            <ng-container matColumnDef="email">
              <th mat-header-cell *matHeaderCellDef> Email Address </th>
              <td mat-cell *matCellDef="let element">
                <div class="email-info">
                  <mat-icon class="email-icon">email</mat-icon> {{element.email}}
                </div>
              </td>
            </ng-container>

            <ng-container matColumnDef="last_login">
              <th mat-header-cell *matHeaderCellDef> Status </th>
              <td mat-cell *matCellDef="let element">
                <span class="status-badge" [class.verified]="element.last_login" [class.unverified]="!element.last_login">
                  <mat-icon>{{element.last_login ? 'check_circle' : 'mark_email_read'}}</mat-icon>
                  {{element.last_login ? 'Active' : 'Invited'}}
                </span>
              </td>
            </ng-container>

            <ng-container matColumnDef="role">
              <th mat-header-cell *matHeaderCellDef> User Role </th>
              <td mat-cell *matCellDef="let element">
                <span class="role-chip">{{(element.role || 'NA') | titlecase}}</span>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

            <tr class="mat-row no-data-row" *matNoDataRow>
              <td class="mat-cell" colspan="5">
                No data matching the filter.
              </td>
            </tr>
          </table>
          </div>
          } @else {
          <div class="text-center py-12 bg-gray-50 rounded-lg col-span-3">
            <mat-icon class="text-6xl text-gray-400 mb-4">list_alt</mat-icon>
            <p class="text-xl text-gray-600">No users found.</p>
          </div>
          }
          }
        </div>
      </div>

    </mat-drawer-container>
  </div>
</div>
